var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.543 6.99451C21.5576 7.2115 21.5576 7.42848 21.5576 7.64746C21.5576 14.32 16.6045 22.0154 7.54759 22.0154V22.0114C4.87215 22.0154 2.25229 21.2294 0 19.7476C0.389031 19.7955 0.780012 19.8195 1.17197 19.8205C3.38915 19.8225 5.54296 19.0596 7.28726 17.6547C5.18026 17.6137 3.3326 16.2048 2.68714 14.148C3.42523 14.294 4.18574 14.264 4.91018 14.061C2.61304 13.585 0.96039 11.5152 0.96039 9.11135C0.96039 9.08935 0.96039 9.06836 0.96039 9.04736C1.64485 9.43833 2.41121 9.65531 3.19512 9.67931C1.03157 8.19642 0.364656 5.24464 1.67118 2.93682C4.17111 6.09158 7.8596 8.00944 11.8191 8.21242C11.4223 6.45855 11.9644 4.62069 13.2436 3.38778C15.2268 1.47593 18.3459 1.57392 20.2101 3.60677C21.3129 3.38378 22.3698 2.96882 23.337 2.38086C22.9694 3.54977 22.2001 4.5427 21.1725 5.17365C22.1484 5.05566 23.102 4.78768 24 4.37871C23.3389 5.39463 22.5063 6.27957 21.543 6.99451Z",
    fill: "#1D9BF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5ab62c46371256e467f79a3671d4451a.svg";
export { ForwardRef as ReactComponent };